import React, { useState, useRef, useLayoutEffect, useEffect } from "react";

import { Row, Col, Input, Pagination } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { Spin } from "antd";

import { API_URL } from "../../../../constants";
import useAxios from "@use-hooks/axios";
import moment from "jalali-moment";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Approvals/Approvals.css";

// JS Files
import ApprovalsSearch from "./ApprovalsSearch.js";
import ApprovalsList from "./ApprovalsList.js";

const ApprovalsMain = (props) => {
  const [approvals, setApprovals] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(null);
  const [current, setCurrent] = useState(null);
  const [fetch, setFetch] = useState(false);
  const [search, setSearch] = useState();
  const [res, setRes] = useState();
  const [title, setTitle] = useState();
  const [endDate, setEndDate] = useState();
  const [startDate, setStartDate] = useState();
  const [isSearch, setIsSearch] = useState(false);
  const getApprovals = useAxios({
    url:
      isSearch != true
        ? `${API_URL}/Approval_Service/?page=${page}`
        : `${API_URL}/Approval_Service/?page=${page}&search=1&title=${title}&start_date=${startDate}&end_date=${endDate}`,
    trigger: [],
    customHandler: (err, res) => {
      if (res) {
        console.log("data", res.data);
        setFetch(false);
        setApprovals(res.data.results);
        setTotal(res.data.count);
        setCurrent(res.data.current);
        // setIsSearch(false)
      }
    },
  });

  // const getSearch = useAxios({
  //   method: "POST",
  //   options: {
  //     data: search,
  //   },
  //   url: `${API_URL}/Approval_Service/search/`,
  //   //     options: {
  //   //       headers: {
  //   //         Authorization: authHeader(),
  //   //       },
  //   //     },
  //   // trigger: search,

  //   // forceDispatchEffect: () => !!search,
  //   customHandler: (err, res) => {
  //     if (res) {
  //       console.log("data", res.data);
  //       setFetch(false);
  //       setApprovals(res.data.results);
  //       setTotal(res.data.count);
  //       setCurrent(res.data.current);
  //       // setIsSearch(false);

  //       // setFetch(false);
  //       // setApprovals(res.data.results);
  //       // setTotal(res.data.count);
  //       // setCurrent(res.data.current);
  //     }
  //   },
  // });

  // const firstUpdate = useRef(true);
  // useLayoutEffect(() => {
  //   if (firstUpdate.current) {
  //     firstUpdate.current = false;
  //     return;
  //   }
  //   console.log("here");

  //   getSearch.reFetch();
  // }, [search]);

  const changePagination = (page, pageSize) => {
    setPage(page);
    setFetch(true);
    getApprovals.reFetch();
  };

  const searchSubmit = (title, startDate, endDate) => {
    // const formData = new FormData();
    // formData.append("title", title);
    // formData.append("start_date", startDate);
    // formData.append("end_date", endDate);
    setIsSearch(false);

    setTitle(title);
    setStartDate(startDate);
    setEndDate(endDate);
    setIsSearch(true);
    getApprovals.reFetch();
    // setSearch(formData);

    // console.log(startDate, endDate);
  };

  return props.size === "laptopdesktop" ? (
    <div className="ApprovalsBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft">
            <strong>مصوبات شورای عالی بیمه</strong>
          </p>
        </Center>
        <Center>
          <p className="mainTitleDescription">لیست مصوبات شورای عالی بیمه</p>
        </Center>
      </div>
      <div style={{ marginTop: "75px" }}>
        <Row>
          <Col span={9}></Col>
          <Col span={6} style={{zIndex:1000}}>
            <ApprovalsSearch
              is_search={isSearch}
              approvals={approvals.length}
              search={searchSubmit}
              size="laptopdesktop"
            />
          </Col>
          <Col span={9}></Col>
        </Row>
      </div>
      <Margin top={4}></Margin>
      <div style={{ backgroundColor: "#ededed" }}>
        <Row style={{ padding: "20px" }}>
          <Col span={4}></Col>
          <Col span={16}>
            <Spin spinning={fetch}>
              {approvals.map((item, index) => {
                return [
                  <>
                    <ApprovalsList
                      key={index}
                      size="laptopdesktop"
                      color="#f9f9f9"
                      date={moment(item.created_at, "YYYY/MM/DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")}
                      title={item.title}
                      number={index + 1}
                      id={item.id}
                      history={props.history}
                    />
                    <Margin top={3}></Margin>
                  </>,
                ];
              })}

              <Center>
                {" "}
                {getApprovals.response?.data && (
                  <Pagination
                    style={{ textAlign: "right", fontFamily: "IranSans" }}
                    simple
                    current={current}
                    pageSize={parseInt(getApprovals.response?.data?.pageSize)}
                    total={total}
                    onChange={changePagination}
                  />
                )}{" "}
              </Center>
            </Spin>
          </Col>
          <Col span={4}></Col>
        </Row>
      </div>
    </div>
  ) : props.size === "tablet" ? (
    <div className="ApprovalsBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft">
            <strong>مصوبات شورای عالی بیمه</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionTablet">
              لیست مصوبات شورای عالی بیمه
            </p>
          </Margin>
        </Center>
      </div>
      <div style={{ marginTop: "25px" }}>
        <Row>
          <Col span={6}></Col>
          <Col span={12}>
            <ApprovalsSearch search={searchSubmit} size="tablet" />
          </Col>
          <Col span={6}></Col>
        </Row>
      </div>
      <Margin top={4}></Margin>
      <div style={{ backgroundColor: "#ededed" }}>
        <Row style={{ padding: "20px" }}>
          <Col span={2}></Col>
          <Col span={20}>
            <Spin spinning={fetch}>
              {approvals.map((item, index) => {
                return [
                  <>
                    <ApprovalsList
                      key={index}
                      size="tablet"
                      color="#f9f9f9"
                      date={moment(item.created_at, "YYYY/MM/DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")}
                      title={item.title}
                      number={index + 1}
                      id={item.id}
                      history={props.history}
                    />
                    <Margin top={3}></Margin>
                  </>,
                ];
              })}

              <Center>
                {" "}
                {getApprovals.response?.data && (
                  <Pagination
                    style={{ textAlign: "right", fontFamily: "IranSans" }}
                    simple
                    current={current}
                    pageSize={parseInt(getApprovals.response?.data?.pageSize)}
                    total={total}
                    onChange={changePagination}
                  />
                )}{" "}
              </Center>
            </Spin>
          </Col>
          <Col span={2}></Col>
        </Row>
      </div>
    </div>
  ) : (
    <div className="ApprovalsBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile">
            <strong>مصوبات شورای عالی بیمه</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionMobile">
              لیست مصوبات شورای عالی بیمه
            </p>
          </Margin>
        </Center>
      </div>
      <div style={{ marginTop: "25px" }}>
        <Row>
          <Col span={2}></Col>
          <Col span={20}>
            <ApprovalsSearch search={searchSubmit} />
          </Col>
          <Col span={2}></Col>
        </Row>
      </div>
      <Margin top={4}></Margin>
      <div style={{ backgroundColor: "#ededed" }}>
        <Row style={{ padding: "20px" }}>
          <Col span={1}></Col>
          <Col span={22}>
            <Spin spinning={fetch}>
              {approvals.map((item, index) => {
                return [
                  <>
                    <ApprovalsList
                      key={index}
                      color="#f9f9f9"
                      date={moment(item.created_at, "YYYY/MM/DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")}
                      title={item.title}
                      number={index + 1}
                      id={item.id}
                      history={props.history}
                    />
                    <Margin top={3}></Margin>
                  </>,
                ];
              })}

              <Center>
                {" "}
                {getApprovals.response?.data && (
                  <Pagination
                    style={{ textAlign: "right", fontFamily: "IranSans" }}
                    simple
                    current={current}
                    pageSize={parseInt(getApprovals.response?.data?.pageSize)}
                    total={total}
                    onChange={changePagination}
                  />
                )}{" "}
              </Center>
            </Spin>
          </Col>
          <Col span={1}></Col>
        </Row>
      </div>
    </div>
  );
};

export default ApprovalsMain;
